// extracted by mini-css-extract-plugin
module.exports = {"container":"_27NyLfyIAu_WMjYbogNh64","item":"_1w8E84_m5zcQxyxKpXK35a","dot":"_1E8OCTgkIZoiYDEnL4UBbu"};